import { ContactStatus } from '@dev/ee-api/ee-api-models';

export const contactsStatuses: { value: ContactStatus; label: string }[] = [
    {
        value: ContactStatus.Transactional,
        label: 'transactional',
    },
    {
        value: ContactStatus.Active,
        label: 'active',
    },
    {
        value: ContactStatus.Inactive,
        label: 'inactive',
    },
    {
        value: ContactStatus.Unsubscribed,
        label: 'unsubscribed',
    },
    {
        value: ContactStatus.Abuse,
        label: 'complaint',
    },
];
